/* eslint-disable eqeqeq */
/* eslint-disable import/no-anonymous-default-export */
import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { api } from "../../config/api";
import { openChannelChat, CHANNEL_FAIL_MESSAGE } from "../../config/channelTalk";
import { util } from "../../config/util";
import { Cookies } from "../../constants/Cookies";
import { pages } from "../../constants/PagePaths";
import AlertContext from "../../contexts/AlertContext";
import InquiryPresenter from "./InquiryPresenter";

interface Props {}

export default (props: Props) => {
  const megaByte = 1000 * 1000;
  const fileSizeLimit = 20; //10MB

  const fileCountLimit = 5;
  const [isSended, setIsSended] = useState(false);
  const [inquiryFiles, setInquiryFiles] = useState<File[]>([]);
  const [fileNames, setFileNames] = useState<string[]>([]);
  const alertContext = useContext(AlertContext);
  const history = useHistory();

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (isSended) return;

    // 전화번호 유효성 검증 — 지역번호(02-, 031- 등)·전국 대표번호(1588- 등)도 받는다
    const phoneInput = e.target.phone_number;
    const phoneNumber = phoneInput.value.replace(/-/g, '');
    const phonePattern = /^(0\d{8,10}|1[5-8]\d{6})$/;

    if (!phonePattern.test(phoneNumber)) {
      alertContext.showAlert('올바른 전화번호를 입력해주세요.\n(예: 02-000-0000, 1588-0000, 010-0000-0000)');
      return;
    }

    const formData = new FormData();
    for (let index = 0; index < e.target.length; index++) {
      const element = e.target[index];
      if (
        (element.type === "text" ||
          element.type === "textarea" ||
          element.type === "email" ||
          element.type === "number" ||
          element.type === "tel") &&
        element.name != "" &&
        element.name !== "company" &&
        element.name !== "content"
      ) {
        formData.append(element.name, element.value);
      } else if (element.type === "radio") {
        if (element.checked) {
          formData.append(element.name, element.parentElement.innerText);
        }
      }
    }

    // 협업문의는 문의 종류를 고르지 않는다. 서버 inquiry_type 은 비어 있으면 안 되므로 고정값.
    // 회사명은 저장할 칸이 따로 없어 내용 맨 앞에 붙인다.
    formData.append("inquiry_type", "협업문의");
    formData.append(
      "content",
      `[회사명] ${e.target.company.value.trim()}\n\n${e.target.content.value}`
    );

    inquiryFiles.forEach((file) => formData.append("files", file));
    formData.append("enctype", "multipart/form-data");
    setIsSended(true);
    alertContext.showAlert("전송중입니다...");
    try {
      const res = await api.postInquiry(formData);
      if (res.status === 200) {
        alertContext.showAlert(
          "협업문의가 접수되었습니다.\n기재하신 이메일을 통해\n추후 개별 연락이 진행될 예정입니다.",
          () => {
            const key = util.getCookie(Cookies.authKey);
            if (key) {
              history.push(pages.mypageqna);
            } else {
              history.push(pages.index);
            }
          }
        );
      }
    } catch (err: any) {
      const errorMessage = err?.response?.data?.message ||
        "문의 전송 중 오류가 발생하였습니다.\n우측 하단 아이콘을 통해 고객센터에 문의 부탁드립니다.";
      alertContext.showAlert(errorMessage);
      setIsSended(false);
    }
  };

  const handleFileAttachAsync = async (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    e.preventDefault();
    if (e.target.files) {
      if (e.target.files?.length === 0) return;
      const files = [];
      const filenames: string[] = [];
      let lengthSum = 0;
      for (let i = 0; i < (e.target.files.length || 0); i++) {
        let file = e.target.files[i];
        lengthSum += file.size;
        if (lengthSum < fileSizeLimit * megaByte && i < fileCountLimit) {
          files.push(file);
          filenames.push(file.name);
        } else {
          alertContext.showAlert(
            `파일은 최대 ${fileCountLimit}개, 합계 ${fileSizeLimit}MB를 넘을 수 없습니다.`
          );
          break;
        }
      }
      setInquiryFiles(files);
      setFileNames(filenames);
    }
  };
  return (
    <InquiryPresenter
      attachedFiles={fileNames}
      onSubmit={handleSubmit}
      onChangeFiles={handleFileAttachAsync}
      onOpenChat={() =>
        openChannelChat(() => alertContext.showAlert(CHANNEL_FAIL_MESSAGE))
      }
    />
  );
};
